import Component from 'inferno-component';
import DateUtils from '../Utils/DateUtils';
import './ProjectInfo.css';
import './ProjectInfoMobile.css';

const ESC_KEY_CODE = 27;

class ProjectInfo extends Component {
  constructor(props) {
    super(props);
    this.state = { project: props.data, isOpen: false };
    this.bindKeyEvents();
  }

  componentWillReceiveProps(nextProps) {
    if (this.shouldUpdate(nextProps)) {
      this.setState({ project: nextProps.data, isOpen: true, eventId: nextProps.eventId });
    }
  }

  shouldUpdate(nextProps) {
    if (nextProps && nextProps.data) {
      return (!this.state.project) ||
        (this.state.project &&
          ((nextProps.data.name !== this.state.project.name) || (nextProps.eventId !== this.state.eventId))
        );
    }
    return false;
  }

  onScreenshotClick = (photoIndex)=> {
    this.props.onScreenshotClick(photoIndex);
  }

  bindKeyEvents = ()=> {
    document.addEventListener('keyup', (event)=> {
      if (event.keyCode === ESC_KEY_CODE) {
        // If the gallery is visible let it's event handler deal with the escape key
        if (!this.props.isGalleryVisible) {
          this.closeProjectInfo();
        }
      }
    });
  }

  closeProjectInfo = ()=> {
    this.setState({ isOpen: false });
  }

  render() {
    const project = this.state.project || {};
    const dateCompleted = DateUtils.longFormatDate(project.date);
    const className = ['project-info', project.type, this.state.isOpen ? 'open' : 'closed'].join(' ');
    const barClass = ['bar', project.type].join(' ');
    const name = project.name;
    const complexity = project.complexity;
    const complexityStyle = 'width:' + Math.round(100 * (complexity / 10)) + '%';
    const happiness = project.happiness;
    const happinessStyle = 'width:' + Math.round(100 * (happiness / 10)) + '%';

    let viewProjectEl = null;
    if (this.state.project && this.state.project.url) {
      viewProjectEl = <a href={ this.state.project.url } class="button" target="_blank">View Project</a>;
    } else {
      viewProjectEl = <div class="not-live"><i class="icon-error_outline"></i>Project not public</div>;
    }

    let projectScreenshots = null;
    if (this.state.project && this.state.project.images) {
      let images = this.state.project.images.map((image, i)=> {
        let style = 'background-image: url(screenshots/' + image.file + ')';
        let className = 'screenshot screenshot-' + i;
        return <div class={ className } style={ style } onClick={ () => { this.onScreenshotClick(i) } }></div>;
      });
      projectScreenshots = <div className="screenshots">{ images }</div>;
    } else {
      projectScreenshots = '';
    }

    return (
      <section className={ className } ref={(el) => { this.frame = el; }}>
        <header>
          <h2>{ name }</h2>
          <div className="close-button icon-keyboard_arrow_right" onClick={ this.closeProjectInfo }></div>
          <div className="external-link-panel">
            { viewProjectEl }
          </div>
          { projectScreenshots }
        </header>
        <div className="rows scroll-group">
          <div className="row">
            <div className="label">Date</div>
            <div className="value">{ dateCompleted }</div>
          </div>
          <div className="row">
            <div className="label">Complexity</div>
            <div className='bar-track'>
              <div className={ barClass } style={ complexityStyle }>
                <div className="value">{ complexity }</div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="label">Fun & Happiness</div>
            <div className='bar-track'>
              <div className={ barClass } style={ happinessStyle }>
                <div className="value">{ happiness }</div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="label">Description</div>
            <div className='content'>
              { project.description }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/ProjectInfo/ProjectInfo.js